import React, { useState } from "react";
import { Form, InputGroup, Button, Row, Col } from "react-bootstrap";
import { STATUS_OPTIONS, COUPON_TYPE_OPTIONS, DISCOUNT_TYPE_OPTIONS } from "utils/promotionalCode";

const PromotionalCodeFilters = ({ filters, onFilterChange, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState(filters.search || "");

  const handleSearch = (e) => {
    e.preventDefault();
    onFilterChange("search", searchTerm);
  };

  const handleClear = () => {
    setSearchTerm("");
    onFilterChange("search", "");
  };

  return (
    <div className="mb-3">
      <Form onSubmit={handleSearch} className="mb-3">
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="Search by code name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button variant="outline-secondary" type="submit">
            Search
          </Button>
          {searchTerm && (
            <Button variant="outline-secondary" onClick={handleClear}>
              Clear
            </Button>
          )}
        </InputGroup>
      </Form>
      <Row className="g-3">
        <Col md={3}>
          <Form.Select
            value={filters.status || ""}
            onChange={(e) => onFilterChange("status", e.target.value)}
          >
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Select
            value={filters.couponType || ""}
            onChange={(e) => onFilterChange("couponType", e.target.value)}
          >
            <option value="">All Coupon Types</option>
            {COUPON_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Select
            value={filters.discountType || ""}
            onChange={(e) => onFilterChange("discountType", e.target.value)}
          >
            <option value="">All Discount Types</option>
            {DISCOUNT_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
    </div>
  );
};

export default PromotionalCodeFilters;

